// extracted by mini-css-extract-plugin
export var expandableReview = "ArticleExpandableReview-module--expandableReview--BnFko";
export var expandTextButton = "ArticleExpandableReview-module--expandTextButton--X_Ata";
export var childrenContainer = "ArticleExpandableReview-module--childrenContainer--1jjyt";
export var collapsed = "ArticleExpandableReview-module--collapsed--3Udnc";
export var edgeSmoothener = "ArticleExpandableReview-module--edgeSmoothener--1-hiA";
export var invisible = "ArticleExpandableReview-module--invisible--u7cvG";